<mat-card style="border-color: #5775a8;">
  <mat-card-header cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="background-color: #5775a8;">
    <div class="flex flex-row rounded-lg w-full" style="align-items: center;">
      <div class="flex flex-col w-full" style="padding-right: 20px;">
        <h4 *ngIf="ids" style="color:white;"><b>Edit Existing Citiaton</b></h4>
        <h4 *ngIf="!ids" style="color:white;"><b>Add New Citation</b></h4>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="form">

      <div class="flex flex-col w-full modal-body">
        <mat-form-field class="container">
          <!-- <mat-label>E-Copy File Received from County</mat-label>
          <input matInput formControlName="countyCopyDate">
          <mat-error *ngIf="form.get('penaltyAmt').invalid">
          </mat-error> -->
          <mat-label>E-Copy File Received from County</mat-label>
          <input matInput [matDatepicker]="countyCopyDate" formControlName="countyCopyDate">
          <mat-datepicker-toggle matSuffix [for]="countyCopyDate"></mat-datepicker-toggle>
          <mat-datepicker #countyCopyDate></mat-datepicker>
          <mat-error *ngIf="form.get('countyCopyDate').invalid">
            Invalid Date.
          </mat-error>
        </mat-form-field>

        <mat-form-field class="container">
          <mat-label>E-Copy File Reviews Completed</mat-label>
          <input matInput [matDatepicker]="dhsReviewDate" formControlName="dhsReviewDate"
            matTooltip="Oregon Health Authority (OHA)">
          <mat-datepicker-toggle matSuffix [for]="dhsReviewDate"></mat-datepicker-toggle>
          <mat-datepicker #dhsReviewDate></mat-datepicker>
          <mat-error *ngIf="form.get('dhsReviewDate').invalid">
            Invalid Date.
          </mat-error>
        </mat-form-field>

        <mat-form-field class="container">
          <mat-label>Department of Justice</mat-label>
          <input matInput [matDatepicker]="dojReviewDate" formControlName="dojReviewDate">
          <mat-datepicker-toggle matSuffix [for]="dojReviewDate"></mat-datepicker-toggle>
          <mat-datepicker #dojReviewDate></mat-datepicker>
          <mat-error *ngIf="form.get('dojReviewDate').invalid">
            Invalid Date.
          </mat-error>
        </mat-form-field>

        <span>Citation Warranted</span>
        <div class="flex flex-row w-full">
          <mat-radio-group formControlName="citationWarranted">
            <mat-radio-button color="primary" class="p-x-8" value="Yes"
              (change)="warrantedFlag('Yes')">Yes</mat-radio-button>
            <mat-radio-button color="primary" class="p-l-8" value="No"
              (change)="warrantedFlag('No')">No</mat-radio-button>
          </mat-radio-group>
        </div>

        <div *ngIf="flagReasonNotIssued == 'No'">
          <mat-form-field class="w-full">
            <mat-label>Reason not issued</mat-label>
            <textarea matInput cdkTextareaAutosize formControlName="notIssuedReason" cdkAutosizeMinRows="2"></textarea>
          </mat-form-field>
        </div>

        <div *ngIf="flagReasonNotIssued == 'Yes'" class="flex flex-col w-full">
          <mat-form-field class="container">
            <mat-label>Notice of Violation and Intent to Impose Civil Penalty issued date</mat-label>
            <input matInput [matDatepicker]="citationIssuedDate" formControlName="citationIssuedDate">
            <mat-datepicker-toggle matSuffix [for]="citationIssuedDate"></mat-datepicker-toggle>
            <mat-datepicker #citationIssuedDate></mat-datepicker>
            <mat-error *ngIf="form.get('citationIssuedDate').invalid">
              Invalid Date.
            </mat-error>
          </mat-form-field>

          <mat-form-field class="container">
            <mat-label>Civil Penalty Amount</mat-label>
            <input matInput formControlName="penaltyAmt">
            <mat-error *ngIf="form.get('penaltyAmt').invalid">

            </mat-error>
          </mat-form-field>

          <span>Hearing Requested?</span>
          <div class="flex flex-row w-full">
            <mat-radio-group formControlName="hearingRequested">
              <mat-radio-button color="primary" class="p-x-8" value="Yes"
                (change)="hearingRequestedFlag('Yes')">Yes</mat-radio-button>
              <mat-radio-button color="primary" class="p-l-8" value="No"
                (change)="hearingRequestedFlag('No')">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <div *ngIf="hearingRequested == 'No'">
            <mat-form-field class="w-full">
              <mat-label>Comments</mat-label>
              <textarea matInput cdkTextareaAutosize formControlName="notIssuedReason"
                cdkAutosizeMinRows="4"></textarea>
            </mat-form-field>
          </div>

          <div *ngIf="hearingRequested == 'Yes'" class="flex flex-col w-full">
            <mat-form-field class="container">
              <mat-label>Hearing Date</mat-label>
              <input matInput [matDatepicker]="hearingDate" formControlName="hearingDate">
              <mat-datepicker-toggle matSuffix [for]="hearingDate"></mat-datepicker-toggle>
              <mat-datepicker #hearingDate></mat-datepicker>
              <mat-error *ngIf="form.get('hearingDate').invalid">
                Invalid Date.
              </mat-error>
            </mat-form-field>

            <mat-form-field class="w-full">
              <mat-label>Result of hearing</mat-label>
              <textarea matInput cdkTextareaAutosize formControlName="hearingReason" cdkAutosizeMinRows="2"></textarea>
            </mat-form-field>

            <mat-form-field class="w-full">
              <mat-label>Comments</mat-label>
              <textarea matInput cdkTextareaAutosize formControlName="notIssuedReason"
                cdkAutosizeMinRows="2"></textarea>
            </mat-form-field>
          </div>

          <span>Final Order Issued?</span>
          <div class="flex flex-row w-full">
            <mat-radio-group formControlName="finalOrderIssued">
              <mat-radio-button color="primary" class="p-x-8" value="Yes"
                (change)="finalOrderIssuedFlag('Yes')">Yes</mat-radio-button>
              <mat-radio-button color="primary" class="p-l-8" value="No"
                (change)="finalOrderIssuedFlag('No')">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <div *ngIf="finalOrderIssued == 'No'">
            <mat-form-field class="w-full">
              <mat-label>Reason not Issued</mat-label>
              <textarea matInput cdkTextareaAutosize formControlName="finalOrderReason"
                cdkAutosizeMinRows="2"></textarea>
            </mat-form-field>
          </div>

          <div *ngIf="finalOrderIssued == 'Yes'">
            <mat-form-field class="container">
              <mat-label>Date mailed</mat-label>
              <input matInput [matDatepicker]="finalOrderDate" formControlName="finalOrderDate">
              <mat-datepicker-toggle matSuffix [for]="finalOrderDate"></mat-datepicker-toggle>
              <mat-datepicker #finalOrderDate></mat-datepicker>
              <mat-error *ngIf="form.get('finalOrderDate').invalid">
                Invalid Date.
              </mat-error>
            </mat-form-field>
          </div>

          <span>Civil Penalty Received?</span>
          <div class="flex flex-row w-full" style="align-items: baseline;">
            <mat-radio-group formControlName="civilPenatly">
              <mat-radio-button color="primary" class="p-x-8" value="Yes"
                (change)="civilPenaltyFlag('Yes')">Yes</mat-radio-button>
              <mat-radio-button color="primary" class="p-l-8" value="No"
                (change)="civilPenaltyFlag('No')">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <div *ngIf="civilPenalty == 'Yes'">
            <mat-form-field class="container">
              <mat-label>Date received in full</mat-label>
              <input matInput [matDatepicker]="fineReceivedDate" formControlName="fineReceivedDate">
              <mat-datepicker-toggle matSuffix [for]="fineReceivedDate"></mat-datepicker-toggle>
              <mat-datepicker #fineReceivedDate></mat-datepicker>
              <mat-error *ngIf="form.get('fineReceivedDate').invalid">
                Invalid Date.
              </mat-error>
            </mat-form-field>
          </div>

          <span>Settlement Agreement Reached?</span>
          <div class="flex flex-row w-full">
            <mat-radio-group formControlName="settlementAgreement">
              <mat-radio-button color="primary" class="p-x-8" value="Yes"
                (change)="settlementAgreementFlag('Yes')">Yes</mat-radio-button>
              <mat-radio-button color="primary" class="p-l-8" value="No"
                (change)="settlementAgreementFlag('No')">No</mat-radio-button>
            </mat-radio-group>
          </div>
          <div *ngIf="settlementAgreement == 'Yes'" class="flex flex-col w-full">
            <mat-form-field class="container">
              <mat-label>Penalty amount due (total)</mat-label>
              <input matInput formControlName="saAmt">
              <mat-error *ngIf="form.get('saAmt').invalid">
              </mat-error>
            </mat-form-field>
            <mat-form-field class="container">
              <mat-label>Amount required upon settlement</mat-label>
              <input matInput formControlName="saRequiredAmt">
            </mat-form-field>
            <mat-form-field class="container">
              <mat-label>Amount held in abeyance (if any)</mat-label>
              <input matInput formControlName="saAbeyance">
            </mat-form-field>
            <mat-form-field class="container">
              <mat-label>Date signed by OHA</mat-label>
              <input matInput [matDatepicker]="saSigned" formControlName="saSigned">
              <mat-datepicker-toggle matSuffix [for]="saSigned"></mat-datepicker-toggle>
              <mat-datepicker #saSigned></mat-datepicker>
              <mat-error *ngIf="form.get('saSigned').invalid">
                Invalid Date.
              </mat-error>
            </mat-form-field>
            <mat-form-field class="container">
              <mat-label>Settlement Agreement in effect until</mat-label>
              <input matInput [matDatepicker]="saUntil" formControlName="saUntil"
                matTooltip="(One year from the Date signed by OHA)">
              <mat-datepicker-toggle matSuffix [for]="saUntil"></mat-datepicker-toggle>
              <mat-datepicker #saUntil></mat-datepicker>
              <mat-error *ngIf="form.get('saUntil').invalid">
                Invalid Date.
              </mat-error>
            </mat-form-field>
            <mat-form-field class="container">
              <mat-label>Date amount required upon settlement received in full</mat-label>
              <input matInput [matDatepicker]="saPaid" formControlName="saPaid">
              <mat-datepicker-toggle matSuffix [for]="saPaid"></mat-datepicker-toggle>
              <mat-datepicker #saPaid></mat-datepicker>
              <mat-error *ngIf="form.get('saPaid').invalid">
                Invalid Date.
              </mat-error>
            </mat-form-field>
          </div>

        </div>

        <div class="flex flex-row ">
          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="save()" class="m-8 container" style="background: #7ABDF3;">
              Save
            </button>
          </div>
          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="return()" class="m-8 container">
              Return
            </button>
          </div>
        </div>
      </div>
    </form>

  </mat-card-content>

</mat-card>